import './index.scss'
export default function BaseButton({ disabled, onClick, children, className = '', style, type = 'button', ...restProps }) {
  return (
    <button type={type} className={`BaseButton ${className}`.trim()} style={style} disabled={disabled} onClick={onClick} {...restProps}>
      {children}
    </button>
  )
}
